import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { DataGrid } from '@material-ui/data-grid';
import { sendGetRequest, cancelGetRequest } from '../../../utils/api';
import { Select } from '@material-ui/core/';

import { snakeCase, camelCase } from 'lodash';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import {
	Grid,
	FormControl,
	InputAdornment,
	InputLabel,
    OutlinedInput,
	IconButton,
    TextField,
    Button,
	
} from '@material-ui/core/';


import ModalContentContainer from 'components/ModalContentContainer';
import { Fragment } from 'react';
import { ErrorAlert } from 'components/Alerts';
import ListAltIcon from '@material-ui/icons/ListAlt';
import SubjectIcon from '@material-ui/icons/Subject';
import { ContactsOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
	input: {
		margin: '5px',
        padding: '5px',
	},
	chip: {
		margin: theme.spacing(0.5),
	},
	button:{
		backgroundColor: '#2e3092',
		color: '#FFFFFF'
	},
}));

const PickListV2 = (props) => {
	const classes = useStyles();
	
    const {
		name,
		label,
        columns,
		variant,
		value,
		onChange,
		helperText,
		error,
		table,
		display,
		Form,
		limit,
		queryStrings,
        readOnly,
        required,
		setValue,
		inputType,
		disabled,
		capturedItems,
		columns2,
	} = props;

	
	const [queryField, setQueryField] = useState('');
	const [searchValue, setSearchValue] = useState('');

	const [fetchingData, setFetchingData] = useState(false);
	
	const [detailsModalOpen, setDetailsModalOpen] = useState(false);
	const [modalGroupOpen, setModalGroupOpen] = useState(false);

	const [activeRecord, setActiveRecord] = useState({});
	const [rows, setRows] = useState([]);
	const [status, setStatus] = useState('');
	const [selection, setSelection] = useState([]);

	const [personGroupList, setPersonGroupList] = useState([]);
	const [personGroup, setPersonGroup] = useState('');

	const [groupName, setGroupName] = useState('');

	const [selectedNames, setSelectedNames] = useState([]);

	const [anchorEl, setAnchorEl] = React.useState(null);
	const [deletedRows, setDeletedRows] = useState([]);

	const handleClick = (event) => {
		console.log("EVENT CURRENT TARGET", event.currentTarget)
		setAnchorEl(event.currentTarget);
	};

	const handleClose = async (e, target) => {
		if(target === 'Person'){
			setDetailsModalOpen(true);
		}

		if(target === 'Group'){
			const path = `/misc?config_type=AssigneeGroups`;
				
			sendGetRequest(path).then((res) => {
				const items = [];
				
				if (res.error) {
					return;
				}
				for(const item of res.data){
					items.push({id: item.idMaster, value: item.configName, extendedValue: item.extendedValue});
				}
				//localStorage.setItem('room', JSON.stringify(items));
				setPersonGroupList(items);

			});
			
			setModalGroupOpen(true);
		}

		setAnchorEl(null);
	};

	const setSelectedValue = (val) => {
		onChange({ target: { name, value: val } });
	};

   
	const handleChange = (e) => {
		console.log("FROM PARENT COMPONENT", value);
		e.preventDefault();
		setSearchValue(e.target.value);
	};

	const handleSearch = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			setSearchValue(e.target.value);
		}
	};
	
	const handleChangeQueryField = (e) => {
		console.log("HANDLE QUERY FIELD:", e.target)
		e.preventDefault();
		setQueryField(e.target.value);
	};
	
	const handChangePersonGroup = (e) => {
		e.preventDefault();
		
		var index = e.target.selectedIndex;
		var optionElement = e.target.childNodes[index];
		var option =  optionElement.getAttribute('data-value');

		console.log("data-value 1:", e);
		console.log("data-value 2:", option);


		if(e.target.value){
			setPersonGroup(e.target.value);
			setSelectedNames(JSON.parse(e.target.value));
			setGroupName(option);
		}
		
		
		
	};


	const handleSearchValue = (e) => {
		e.preventDefault();
		setSearchValue(e.target.value);
	};

	const searchDB = async (e) =>{
		if(queryField.length === 0) return;
		if(searchValue.length === 0) return;

		const queryFieldSnakeCase = snakeCase(queryField);
		const path = `${table}?${queryFieldSnakeCase}=${searchValue}`;
		const res = await sendGetRequest(path);
		const tempData = [];


		if(res.data){
			for(const item of res.data){
				//const red = columns.reduce((acc, col)=> acc = {...acc, [col.field]:item[col.field]} );
				let red = {}
				for(const col of columns){
					red = {...red,id:genKey(), [col.field]:item[col.field]}
				}
				tempData.push(red);
			}
		}
		setRows(tempData)
		console.log(tempData)
	}
	
	const closeDetailsModal = () => {
		setDetailsModalOpen(false);
	};

	const closeGroupModal = () =>{
		setModalGroupOpen(false);
	}

    const openList = (e) =>{
		console.log("CAPTURED FROM PARENT :", value);
		if(disabled === true) return;
        e.preventDefault();
		setActiveRecord(rows.find((row) => row.id === value));
		setDetailsModalOpen(true);
    }

	const genKey = () => {
		var d = new Date();
		var n =  d.getTime();
	
		let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
		let str = '';
		for (let i = 0; i < 4; i++) {
			str += chars.charAt(Math.floor(Math.random() * chars.length));
		}
	
		str = str + n.toString();
		return str;
	}

	const setRecord = (type) =>{
		
		if(type === 'Person'){
			setValue(selection, type);
			setDetailsModalOpen(false);
			
		}else{

			if(personGroup){
				let tempItems = JSON.parse(personGroup);
				setValue(tempItems, type, groupName);
				setModalGroupOpen(false);
			}
		
		}
		
		
	}

	const cancel = () =>{
		
		setDetailsModalOpen(false);
		setSelection([]);
	}

	//updated to support multiple selection
	const handleRowSelection = (e) => {

		let selectedItems;

		if(limit && limit === 'multiple')
			selectedItems = JSON.parse(JSON.stringify(selection));
		else
			selectedItems = [];
			
		

		for(const item of e){
			let selected = rows.filter(row => row.id === item);

			
			let find = selectedItems.filter(row => row.id === item);

			if(find.length === 0)
				selectedItems.push(selected[0]);
		}
		setSelection(selectedItems);
		
	}

	const handleRowSelectionDelete = (e) => {
		
		try{
			let selectedItems = JSON.parse(JSON.stringify(selection));

			if(selectedItems.length > 0){
				for(const item of e){
					let selected = selectedItems.filter(row => row.id !== item);
	
					setSelection(selected);		
				}
			}else{
				setSelection([]);		
			}
		}catch(error){

			console.log("SELECTION ERROR", error);

		}

		
			
		
		
	}

	const handleRowSelectionGroup = (e) =>{
		console.log("SELECTED", e);
		let selectedItems;

		if(limit && limit === 'multiple')
			selectedItems = JSON.parse(JSON.stringify(selection));
		else
			selectedItems = [];
			
		

		for(const item of selectedNames){
		  selectedItems.push({empId: item.id, fullName: item.fullName})
		}
		
		setSelection(selectedItems);
	}

	useEffect(() => {
		if(capturedItems && capturedItems.length > 0){
			setSelection(capturedItems);
		}
	},[capturedItems]);

	useEffect(()=>{
		setQueryField(columns[1].field);
	},[])

	return (
		<div>
			{status ? (
				<ErrorAlert>Failed:{status}</ErrorAlert>
			) : (
				<Fragment>
				
						
						<FormControl  variant="outlined" fullWidth>
                       
                        <InputLabel htmlFor={name}>{label}</InputLabel>
                        <OutlinedInput
                            id = { name }
                            type = {'text'}
                            name = { name }
                            value = { value }
                            required = { required || false }
                            onChange = { handleChange }
                            label={label}
							
                            endAdornment={
                                
                                    readOnly === true  ?
                                    <InputAdornment position="end">
                                    
                                        <IconButton
                                        edge="end"
                                        onClick={(e)=>{openList(e)}}
                                        aria-describedby={name}
                                        >
                                            
                                            <ListAltIcon /> 
                                        </IconButton> 
                                    
                                    </InputAdornment> : 
                                    
                                    <InputAdornment position="end">
                                
                                    <IconButton
                                    edge="end"
                                    onClick={(e)=>{handleClick(e)}}
                                    aria-describedby={name}
                                    >
                                        
                                        <SubjectIcon /> 
                                    </IconButton> 
									
                                    </InputAdornment>
                                        
                                
                                
                            }

                           
                            error={props.error}
                        />
						<Menu
						  id="simple-menu"
						  anchorEl={anchorEl}
						  keepMounted
						  open={Boolean(anchorEl)}
						  onClose={handleClose}
						>
						  <MenuItem onClick={(e)=>handleClose(e,'Person')}>Person</MenuItem>
						  <MenuItem onClick={(e)=>handleClose(e,'Group')}>Person Group</MenuItem>
						  
						</Menu>
                    	</FormControl>	
					
					
					
					<ModalContentContainer
						open={detailsModalOpen}
						handleClose={closeDetailsModal}
					>
						<Grid
                           container
                           direction="row"
                           justifyContent="center"
                           alignItems="center"
                           spacing={3}
                        >
                            <Grid item xs={12}>Search:</Grid>
                            
                            <Grid item xs={12} md={5}>
                                <TextField
                                    id = 'searchValue'
                                    label= 'Search Value'
                                    variant="outlined"
                                    name = 'searchValue'
                                    fullWidth
                                    value={ searchValue }
                                    onChange={(e) => handleSearchValue(e)}
                                    className={classes.input}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl variant="outlined" fullWidth className={classes.input} >
                                    <InputLabel htmlFor="queryField">Query Field</InputLabel>
                                    <Select
										native
										
										value = {queryField}
										onChange = { (e) => handleChangeQueryField(e) }
										label="Query Field"
										inputProps={{
											name: 'queryField',
											id: 'queryField',
										}}
                                    >
                                    <option aria-label="None" value="" />

									{
										columns ? columns.map((column)=>{
											return(<option key={genKey()} value = {column.field}> {column.headerName} </option>)
										})	: null

										
									}
                                  
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=> searchDB(e)}>
                                        Search
                                </Button>
								<Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=>{cancel(e)}}>
							 			Cancel
						 		</Button>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing = {3}
                        >
                            <Grid item xs={12}>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        pageSize={10}
                                        rowsPerPageOptions={[20]}
                                        checkboxSelection={false}
                                        disableMultipleSelection={true}
										onSelectionModelChange = {handleRowSelection}
                                    />
                                </div>
                            </Grid>
							<Grid item xs = {12}>
								<h3>Selection:</h3>
								<div style={{ height: 200, width: '100%' }}>
                                    <DataGrid
                                        rows={selection}
                                        columns={columns}
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
										onSelectionModelChange = {handleRowSelectionDelete}
										
                                    />
                                </div>
							</Grid>
							<Grid item xs={12} md={2}></Grid>
							<Grid item xs={12} md={4}>
                                <Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=> setRecord('Person')}>
                                        OK
                                </Button>
                            </Grid>
							
							<Grid item xs={12} md={4}>
								<Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=> setDetailsModalOpen(false)}>
                                        Cancel
                                </Button>
							</Grid>
							<Grid item xs={12} md={2}></Grid>
                        </Grid>
					</ModalContentContainer>


					<ModalContentContainer
						open={modalGroupOpen}
						handleClose={closeGroupModal}
					>
						<Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing = {3}
                        >
                            <Grid item xs={12}>Person Group:</Grid>
                            
                            
                            <Grid item xs={12} md={12}>
                                <FormControl variant="outlined" fullWidth >
                                    <InputLabel htmlFor="personGroup">Person Group</InputLabel>
                                    <Select
										native
										
										value = {personGroup}
										onChange = { (e) => handChangePersonGroup(e) }
										label="Person Group"
										inputProps={{
											name: 'personGroup',
											id: 'personGroup',
										}}
                                    >
                                    <option aria-label="None" value="" />

									{
										personGroupList ? personGroupList.map((column)=>{
											return(<option key={genKey()} value = {column.extendedValue} data-value={column.value}> {column.value} </option>)
										})	: null
									}
                                  
                                    </Select>
                                </FormControl>
                            </Grid>
                           
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing = {3}
                        >
                            <Grid item xs={12}>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataGrid
                                        rows={selectedNames}
                                        columns={columns2}
                                        pageSize={10}
                                        rowsPerPageOptions={[20]}
                                        checkboxSelection={false}
                                        disableMultipleSelection={true}
										onSelectionModelChange = {()=>handleRowSelectionGroup()}
                                    />
                                </div>
                            </Grid>
							<Grid item xs={12} md={2}></Grid>
							<Grid item xs={12} md={4}>
                                <Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=> setRecord('Group')}>
                                        OK
                                </Button>
                            </Grid>
							
							<Grid item xs={12} md={4}>
								<Button variant="contained" color="primary" className={classes.input} fullWidth onClick={(e)=> setModalGroupOpen(false)}>
                                        Cancel
                                </Button>
							</Grid>
							<Grid item xs={12} md={2}></Grid>
                        </Grid>
					</ModalContentContainer>
				</Fragment>
			)}
		</div>
	);
};


PickListV2.defaultProps = {
	helperText: '',
	limit: 7,
	queryStrings: {},
};

export default PickListV2;
